const siteKey = "site_pub_790004d20a284c22be8ae3d429e05ffd";
const embedUrl = "https://analysis.itsaazdev.ir/widget/embed.js";
type Mode = "chat" | "contact";
interface Instance {
  frame: HTMLIFrameElement | null;
  ready: Promise<HTMLIFrameElement>;
}
const instances = new Map<Mode, Instance>();

function parking(): HTMLElement {
  let element = document.getElementById("paya-support-parking");
  if (!element) {
    element = document.createElement("div");
    element.id = "paya-support-parking";
    element.hidden = true;
    document.body.append(element);
  }
  return element;
}

export function mountPaya(mode: Mode, target?: HTMLElement): () => void {
  let instance = instances.get(mode);
  if (!instance) {
    const script = document.createElement("script");
    script.src = embedUrl;
    script.async = true;
    script.dataset.siteKey = siteKey;
    script.dataset.mode = mode;
    script.dataset.theme = "light";
    script.dataset.mobileBottomOffset = "88";
    if (mode === "contact") {
      script.dataset.target = "#paya-support-parking";
      parking().dataset.payaContact = siteKey;
    }
    const created: Instance = {
      frame: null,
      ready: new Promise<HTMLIFrameElement>((resolve, reject) => {
        script.addEventListener(
          "load",
          () => {
            const frame = [...document.querySelectorAll<HTMLIFrameElement>("iframe")].find(
              (candidate) => {
                const url = new URL(candidate.src, document.baseURI);
                return (
                  url.origin === "https://analysis.itsaazdev.ir" &&
                  url.searchParams.get("siteKey") === siteKey &&
                  url.searchParams.get("mode") === mode
                );
              },
            );
            if (!frame) {
              reject(new Error("Support widget is unavailable."));
              return;
            }
            created.frame = frame;
            resolve(frame);
          },
          { once: true },
        );
        script.addEventListener(
          "error",
          () => reject(new Error("Support widget is unavailable.")),
          {
            once: true,
          },
        );
      }),
    };
    instance = created;
    instances.set(mode, instance);
    document.body.append(script);
  }
  let active = true;
  // The vendor has no destroy API. Keep one loader/listener set per document and
  // reuse its frame rather than executing the vendor script on every route/effect.
  void instance.ready
    .then((frame) => {
      if (active && target?.isConnected) target.append(frame);
    })
    .catch(() => {
      // Telephone/email fallback is always visible; never infer bootstrap success.
    });
  return () => {
    active = false;
    if (mode === "contact" && instance.frame && target?.contains(instance.frame)) {
      parking().append(instance.frame);
    }
  };
}
